// src/hooks/useAdminProperties.js
import { useState, useEffect } from 'react';
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  where
} from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from './useAuth';

export const useAdminProperties = () => {
  const { user, isAdmin } = useAuth();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user?.uid || !isAdmin) {
      if (isAdmin === false) {
        setProperties([]);
        setLoading(false);
      }
      return;
    }

    setLoading(true);
    setError(null);

    // Properties are customerProfiles that have a non-empty address field
    const q = query(
      collection(db, 'customerProfiles'),
      where('address', '!=', ''),
      orderBy('address'),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const list = snapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            // Normalize fields so existing callers keep working
            name: `${data.firstName || ''} ${data.lastName || ''}`.trim() || 'Unknown',
            address: data.address || '',
            ownerName: `${data.firstName || ''} ${data.lastName || ''}`.trim() || 'Unknown',
            ownerEmail: data.email || '',
            ownerId: doc.id,
            phone: data.phone || '',
            email: data.email || '',
            notes: data.notes || '',
            createdAt: data.createdAt?.toDate() || new Date(),
            updatedAt: data.updatedAt?.toDate() || new Date(),
          };
        });
        setProperties(list);
        setLoading(false);
      },
      (err) => {
        console.error('useAdminProperties error:', err);
        setError('Failed to load properties.');
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [user?.uid, isAdmin]);

  return {
    properties,
    loading,
    error,
    clearError: () => setError(null),
  };
};

export default useAdminProperties;